import React, { useRef, useState } from "react";
import "./Plan.css";
import { useNavigate } from "react-router-dom";
import SuccessComponent from "../SuccessComponent/SuccessComponent";
const amounts = [
  {
    base: {
      price: "3500",
      totalPrice: "10500",
      name: "PER QUATERLY",
      plan: "quaterly base ",
    },
    premium: {
      price: "5000",
      totalPrice: "15000",
      name: "PER QUATERLY",
      plan: "quaterly premium ",
    },
    advance: {
      price: "7500",
      totalPrice: "22500",
      name: "PER QUATERLY",
      plan: "quaterly advance ",
    },
  },
  {
    base: {
      price: "3500",
      totalPrice: "17500",
      name: "PER HALF YEARLY",
      month: "   1 Month Free",
      plan: "half yearly base ",
    },
    premium: {
      price: "5000",
      totalPrice: "25000",
      name: "PER HALF YEARLY",
      month: "   1 Month Free",
      plan: "half yearly premium ",
    },
    advance: {
      price: "7500",
      totalPrice: "37500",
      name: "PER HALF YEARLY",
      month: "   1 Month Free",
      plan: "half yearly advance ",
    },
  },
  {
    base: {
      price: "3500",
      totalPrice: "35500",
      name: "PER YEAR",
      month: "   2 Months Free",
      plan: "year base ",
    },
    premium: {
      price: "5000",
      totalPrice: "50000",
      name: "PER YEAR",
      month: "   2 Months Free",
      plan: "year premium ",
    },
    advance: {
      price: "7500",
      totalPrice: "75000",
      name: "PER YEAR",
      month: "   2 Months Free",
      plan: "year advance ",
    },
  },
];

const Plan = () => {
  const [text, setText] = useState();
  const [selectedOption, setSelectedOption] = useState(0); // Track the selected button
  const [amount, setAmount] = useState(amounts[0]);
  const navigate = useNavigate();
  const popupRef = useRef();
  const [loading, setLoading] = useState(false);

  function Price(ev) {
    setText(ev);
  }
  const handleButtonClick = (option) => {
    setSelectedOption(option);
    setAmount(amounts[option]);
  };
  const handleNavigate = () => {
    navigate("/");
  };
  const handleSubmit = async (e, selectedPlan) => {
    if (e && e.preventDefault) e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbwNXhvUzxfnWMMRUlrl0yngKWWkzXTYW7kRYcHajEG4DSTw5gZkMQ0XjjTilTqYyjBB3g/exec";
    setLoading(true);

    try {
      // Retrieve saved signup form data from sessionStorage
      const signupFormData = JSON.parse(
        sessionStorage.getItem("signupFormData")
      );
      if (!signupFormData) {
        popupRef.current.showPopup(
          "Please complete the sign-up form before selecting a plan.",
          "bi bi-exclamation-circle-fill"
        );
        setLoading(false);
        return;
      }

      // Include selected plan details in the payload
      signupFormData.selectedPlan = selectedPlan;

      // Send the data to the Google Apps Script
      const response = await fetch(scriptURL, {
        method: "POST",
        body: new URLSearchParams(signupFormData),
      });

      if (response.ok) {
        popupRef.current.showPopup(
          "Successfully Signed Up! Our executive will contact you shortly.",
          "bi bi-check-circle-fill"
        );
        setTimeout(() => {
          handleNavigate();
        }, 2000);
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      popupRef.current.showPopup("Sign up Failed", "bi bi-x-circle-fill");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="pricing_container">
      <h1>Choose Plan</h1>
      <div className="pricing_buttons">
        <p
          className={`pricing_button_option ${
            selectedOption === 0 ? "pricing_button_selected1" : ""
          }`}
          onClick={() => handleButtonClick(0)}
        >
          Quarterly
        </p>
        <p
          className={`pricing_button_option ${
            selectedOption === 1 ? "pricing_button_selected2" : ""
          }`}
          onClick={() => handleButtonClick(1)}
        >
          Half yearly
        </p>
        <p
          className={`pricing_button_option ${
            selectedOption === 2 ? "pricing_button_selected3" : ""
          }`}
          onClick={() => handleButtonClick(2)}
        >
          Yearly
        </p>
      </div>

      <div className="pricing_prices_container">
        <div
          className={
            text === "one"
              ? "pricing_price_card_hover active"
              : "pricing_price_card"
          }
          onMouseOver={() => Price("one")}
        >
          <p>Basic Plan</p>
          <div className="pricing_price_details">
            <h1>
              ₹{amount.base.price}.<span>00</span>
            </h1>
            <p>Per Month</p>
            {selectedOption > 0 && ( // Display months free for half-yearly or yearly
              <p className="months_free">
                {selectedOption === 1 ? amount.base.month : ""}
                {selectedOption === 2 ? amount.base.month : ""}
              </p>
            )}
          </div>
          <div className="pricing_price_content">
            <p>
              Get essential tools for business management, including analytics,
              project management, HR, finance, and more. Perfect for small teams
              starting their growth journey.
            </p>
          </div>
          <div className="pricing_price_points">
            <p>Dashboard Analytics</p>
            <p>Bussiness Development</p>
            <p>Marketing</p>
            <p>Finance</p>
            <p>HR</p>
            <p>Notes</p>
            <p>Upto 30 Users</p>
          </div>
          <div
            className={
              text === "one" ? "pricing_price_btn_active" : "pricing_price_btn"
            }
          >
            <button
              onClick={(e) => handleSubmit(e, amount.base.plan)}
              disabled={loading === amount.base.plan}
              className="plan_submit_btn"
            >
              {loading === amount.base.plan ? (
                <span className="loader"></span>
              ) : text === "three" ? (
                "Let’s Started"
              ) : (
                "Start now"
              )}{" "}
            </button>
          </div>
          <p className="pricing_card_bottom_price">
            {text === "one"
              ? `${amount.base.name} ${amount.base.totalPrice}/-`
              : ""}
          </p>
        </div>
        <div
          className={
            text === "two"
              ? "pricing_price_card_hover2 active"
              : "pricing_price_card2"
          }
          onMouseOver={() => Price("two")}
        >
          <p>Premium Plan</p>
          <div className="pricing_price_details2">
            <h1>
              ₹{amount.premium.price}.
              <span>
                00{" "}
                {selectedOption > 0 && ( // Display months free for half-yearly or yearly
                  <p className="months_free">
                    {selectedOption === 1 ? amount.premium.month : ""}
                    {selectedOption === 2 ? amount.premium.month : ""}
                  </p>
                )}
              </span>
            </h1>
            <p>Per Month</p>
          </div>
          <div className="pricing_price_content2">
            <p>
              Premium Plan Build on the Basic Plan with advanced features like
              lead generation, chat management, marketing, and seamless form
              integration to elevate your business.
            </p>
          </div>
          <div className="pricing_price_points2">
            <p>Everything in Basic plan</p>
            <p>Lead Generation</p>
            <p>Chat Management</p>
            <p>Priority Support</p>
            <p>Marketing</p>
            <p>Upto 60 Users</p>
            <p>Form Integrations</p>
          </div>
          <div
            className={
              text === "two" ? "pricing_price_btn_active" : "pricing_price_btn2"
            }
          >
            <button
              onClick={(e) => handleSubmit(e, amount.premium.plan)}
              disabled={loading === amount.premium.plan}
              className="plan_submit_btn"
            >
              {loading === amount.premium.plan ? (
                <span className="loader"></span>
              ) : text === "three" ? (
                "Let’s Started"
              ) : (
                "Start now"
              )}{" "}
            </button>
          </div>
          <p className="pricing_card_bottom_price">
            {text === "two"
              ? `${amount.premium.name} ${amount.premium.totalPrice}/-`
              : ""}
          </p>
        </div>
        <div
          className={
            text === "three"
              ? "pricing_price_card_hover active"
              : "pricing_price_card"
          }
          onMouseOver={() => Price("three")}
        >
          <p>Advanced Plan</p>
          <div className="pricing_price_details">
            <h1>
              ₹{amount.advance.price}.<span>00 </span>
            </h1>
            <p>Per Month</p>
            {selectedOption > 0 && ( // Display months free for half-yearly or yearly
              <p className="months_free">
                {selectedOption === 1 ? amount.advance.month : ""}
                {selectedOption === 2 ? amount.advance.month : ""}
              </p>
            )}
          </div>
          <div className="pricing_price_content">
            <p>
              Maximize efficiency with custom form integration, multi-document
              selection, and training resources, alongside all Premium Plan
              features. Ideal for large-scale operations.
            </p>
          </div>
          <div className="pricing_price_points">
            <p>Everything in Premium Plan</p>
            <p>Custom form Integrations</p>
            <p>Multi Document Selection</p>
            <p>Your Website Integration Support</p>
            <p>Dedicated Support</p>
            <p>Training & Learning</p>
            <p>Upto 100 Users</p>
          </div>
          <div
            className={
              text === "three"
                ? "pricing_price_btn_active"
                : "pricing_price_btn"
            }
          >
            <button
              onClick={(e) => handleSubmit(e, amount.advance.plan)}
              disabled={loading === amount.advance.plan}
              className="plan_submit_btn"
            >
              {loading === amount.advance.plan ? (
                <span className="loader"></span>
              ) : text === "three" ? (
                "Let’s Started"
              ) : (
                "Start now"
              )}
            </button>
          </div>
          <p className="pricing_card_bottom_price">
            {text === "three"
              ? `${amount.advance.name} ${amount.advance.totalPrice}/-`
              : ""}
          </p>
        </div>
      </div>
      <SuccessComponent ref={popupRef} />
    </div>
  );
};

export default Plan;
